<div class="product-features">
  <h1 class="main-heading">Evaltrix Product Features</h1>
  <div class="sub-heading">AI-powered skill assessments that help you hire smarter, faster, and fairer.</div>
  <div class="features">
    <div class="feature" *ngFor="let feature of features;  let i = index; let odd=odd; let even=even"
      [attr.id]="'feature-' + i" [ngClass]="{ 'odd-feature': odd, 'even-feature': even }">
      <div class="image-section">
        <img [src]="feature.image" [alt]="feature.title" class="image"
          (error)="$event.target.src='../../../assets/prod-feature1.png'" />
      </div>
      <div class="content-section">
        <h1 class="heading">{{feature.title}}
        </h1>
        <div class="content">
          <p *ngIf="feature.intro">{{feature.intro}}</p>

          <ng-container *ngFor="let group of feature.groups">
            <div class="group" *ngIf="group.items?.length">
              <div class="group-label" *ngIf="group.label">{{group.label}}</div>
              <ul class="group-list">
                <li *ngFor="let item of group.items">{{item}}</li>
              </ul>
            </div>
          </ng-container>

          <div class="why" *ngIf="feature.why">
            <span class="group-label">Why it matters:</span> {{feature.why}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>